import { action } from 'satcheljs';

/**
 * Action to end the search session by clearing the state in the stire and invoking the necessary side effects
 */
export default action('endSearchSession', function endSearchSession() {
    return {};
});
